export class AppSettings {
  public static readonly ENTERPRISE_CODE_MAX_LENGTH = 32;
  public static readonly GENERIC_FIELD_MAX_LENGTH = 255;
  public static readonly MAX_CREDENTIALS_ALLOWED = 5;
  public static readonly QR_ISSUER_LABEL = 'Nomidio Admin Service';
}
